import { ToneDto, ToneDtoImpl } from '../tonedto';

export interface GetBannerPlaylistToneDto extends ToneDto
{
    getPreviewContent(): string;
    getValidity(): string;
    getPlaylistResponseDescription(): string;
    getChannelName(): string;
    getParentToneCode(): string;
    getChildToneCodes(): string;
    getEntityId(): string;
    getType(): string;
}

export class GetBannerPlaylistToneDtoImpl extends ToneDtoImpl implements GetBannerPlaylistToneDto
{
    private previewContent:string;
    private validity:string;
    private playlistResponseDescription:string;
    private channelName:string;
    private parentToneCode:string;
    private childToneCodes:string;
    private entityId:string;
    private type:string;

    getPreviewContent(): string
    {
        return this.previewContent;
    }
    setPreviewContent(previewContent: string)
    {
        this.previewContent = previewContent;
    }

    getValidity(): string
    {
        return this.validity;
    }
    setValidity(validity: string)
    {
        this.validity = validity;
    }
    
    getPlaylistResponseDescription(): string
    {
        return this.playlistResponseDescription;
    }
    setPlaylistResponseDescription(playlistResponseDescription: string)
    {
        this.playlistResponseDescription = playlistResponseDescription;
    }

    getChannelName(): string
    {
        return this.channelName;
    }
    setChannelName(channelName: string)
    {
        this.channelName = channelName;
    }

    getParentToneCode(): string
    {
        return this.parentToneCode;
    }
    setParentToneCode(parentToneCode: string)
    {
        this.parentToneCode = parentToneCode;
    }

    getChildToneCodes(): string
    {
        return this.childToneCodes;
    }
    setChildToneCodes(childToneCodes: string)
    {
        this.childToneCodes = childToneCodes;
    }

    getEntityId(): string
    {
        return this.entityId;
    }
    setEntityId(entityId: string)
    {
        this.entityId = entityId;
    }

    getType(): string
    {
        return this.type;
    }
    setType(type: string)
    {
        this.type = type;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getplaylist/getbannerplaylisttonedto.ts